import React from 'react';

import { Alert, AlertDescription } from '@modernloop/ai-elements';
import { useTranslation } from '@modernloop/i18n';
import { agentErrorMessageKey } from '../agent/agentErrorMessages';
import type { AGENT_TRANSCRIPT_SEGMENT, AgentTranscriptSegment } from '../agent/transcriptSegments';

export type TurnErrorSegment = Extract<AgentTranscriptSegment, { type: typeof AGENT_TRANSCRIPT_SEGMENT.TURN_ERROR }>;

type Props = {
  segment: TurnErrorSegment;
};

/** One failed-turn row of the transcript. */
const TurnErrorPart: React.FC<Props> = ({ segment }) => {
  const { t } = useTranslation();
  return (
    <div className="px-4">
      <Alert data-testid="agent-turn-error" variant="destructive">
        <AlertDescription>
          {/* Backend-localized mint failures render verbatim; transport codes localize here. */}
          {segment.localizedMessage ?? t(agentErrorMessageKey(segment.code))}
        </AlertDescription>
      </Alert>
    </div>
  );
};

export default TurnErrorPart;
